import React from 'react'
import PropTypes from 'prop-types'
import { ActionBar } from './ActionBar'
import { CallAction } from './CallAction'

const CallBottomContainer = ({ isDesktop }) => {
  return <>{isDesktop ? <ActionBar /> : <CallAction />}</>
}

CallBottomContainer.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
}

export { CallBottomContainer }
